<template>
  <el-dialog
    class="select-school-dlg"
    title="请选择您要注册的校区"
    :visible.sync="show"
    width="980px"
    @close="onClose"
  >
    <ul class="province-wrap">
      <li v-for="(province, index) in provinces" :key="index">
        <p class="province-name">{{ province.province_name }}</p>
        <ul class="city-wrap">
          <li v-for="(city, index) in province.city" :key="index">
            <p class="city-name">{{ city.city_name }}</p>
            <ul class="school-wrap">
              <li
                v-for="(school, index) in city.schools"
                :key="index"
                @click="onSchool(school)"
                :class="{ actived: selectSchool.school_id == school.school_id }"
              >
                <span class="district-name">[{{ school.district_name }}]</span>
                <span>{{ school.school_name }}</span>
              </li>
            </ul>
          </li>
        </ul>
      </li>
    </ul>
    <div slot="footer">
      <span class="info-wrap" v-if="selectSchool.school_id">
        <span>您当前选择注册成为</span>
        <span class="info-select">
          [{{ selectSchool.district_name }}] {{ selectSchool.school_name }}
        </span>
        <span>的学员，确定后不可更改</span>
      </span>
      <el-button type="primary" size="medium" @click="onOk">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'SelectSchoolDlg',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      show: false,
      provinces: [],
      selectSchool: {},
    };
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        this.show = val;
      },
    },
  },
  created() {
    this.requestSchools();
  },
  methods: {
    // on event
    onClose() {
      this.$emit('update:visible', false);
    },
    onSchool(school) {
      this.selectSchool = school;
    },
    onOk() {
      this.show = false;
      this.$emit('on-select', this.selectSchool.school_id);
    },
    // 是否单校区
    isSingleSchool() {
      let ret = 0;
      this.provinces.forEach((province) => {
        province.city &&
          province.city.forEach((city) => {
            if (city.schools.length) {
              ret += city.schools.length;
            }
          });
      });
      return ret <= 1;
    },
    getSingleSchoolID() {
      return this.provinces[0].city[0].schools[0].school_id;
    },
    // request
    async requestSchools() {
      this.provinces = await this.$http.get('/api/app/getSchool', {}, { school_id: '0' });
      this.selectSchool = this.provinces[0].city[0].schools[0];
    },
  },
};
</script>

<style lang="scss" scoped>
.select-school-dlg {
  display: flex;
  justify-content: center;
  align-items: center;
}
/*滚动条*/
::-webkit-scrollbar {
  background-color: transparent;
  width: 20px;
  height: 8px;
}

/*滚动条中间滑动部分*/
::-webkit-scrollbar-thumb {
  border-radius: 12px;
  border: 6px solid transparent;
  box-shadow: 8px 0 0 #c0c0c0 inset;
}
::v-deep {
  .el-dialog {
    margin: auto !important;
  }
  .el-dialog__title {
    color: #333;
    font-size: 18px;
    font-weight: bold;
  }
  .el-dialog__body {
    padding: 10px 20px;
    height: calc(100vh - 300px);
    min-height: 300px;
    overflow-y: auto;
  }
  .el-dialog__footer {
    .info-wrap {
      font-size: 14px;
      color: #999;
      margin-right: 12px;
      .info-select {
        color: $primary-color;
        margin: 0 5px;
      }
    }
    .el-button {
      width: 88px;
    }
  }
}
.province-wrap {
  color: #333;
  line-height: 1;
}
.province-name {
  font-size: 16px;
  font-weight: bold;
  border-bottom: 1px solid #e6e6e6;
  padding-bottom: 8px;
}
.city-wrap {
  > li {
    margin: 16px 0;
  }
  .city-name {
    font-size: 14px;
  }
  .school-wrap {
    margin-top: 8px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    &::after {
      content: '';
      width: 30.5%;
    }
    > li {
      display: inline-block;
      width: 30.5%;
      border: 1px solid #e6e6e6;
      border-radius: 4px;
      box-sizing: border-box;
      padding: 7px 8px;
      cursor: pointer;
      margin-bottom: 8px;
      line-height: 1.4;
      &.actived {
        color: #fff;
        background-color: $primary-color;
        border-color: $primary-color;
        .district-name {
          color: #fff;
        }
      }
      &:hover:not(.actived) {
        color: $primary-color;
        background-color: rgba($primary-color, 0.1);
        border-color: transparent;
        .district-name {
          color: $primary-color;
        }
      }
      .district-name {
        margin-right: 5px;
        color: #999;
      }
    }
  }
}
</style>
